import React from 'react';
import { QuestionDetail } from '../components/QuestionDetail';

export interface QuestionDetailViewProps {
  questionId: string;
  onBack: () => void;
}

export function QuestionDetailView({
  questionId,
  onBack,
}: QuestionDetailViewProps): React.ReactElement {
  return (
    <div className="fmp-detail-view">
      <QuestionDetail questionId={questionId} onBack={onBack} />
    </div>
  );
}
